<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">Map My Data - Analysis</h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <Markdown :content="textResponse" />
        </div>
        <div class="card-footer text-end">
            <button class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" type="button">
                Close
            </button>
        </div>
    </div>
</template>
<script>
import Markdown from "../Markdown.vue";
export default {
    components: { Markdown },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    computed: {
        textResponse() {
            return this.modalData?.response?.text_response || null;
        }
    }
}
</script>
<style scoped></style>